import React from 'react';
import Select from 'react-select';

const SearchableSelect = ({ 
  options = [], 
  value, 
  onChange, 
  placeholder = "Sélectionner...",
  isLoading = false,
  isDisabled = false,
  style = {},
  className = "",
  width = "100%"
}) => {
  // Transform options to react-select format if needed
  const formattedOptions = options.map(option => {
    if (typeof option === 'object' && 'value' in option && 'label' in option) {
      return option;
    }
    // Handle the worker format from the existing code
    if (typeof option === 'object' && 'login' in option && 'name' in option) {
      return {
        value: option.login,
        label: option.name
      };
    }
    // Handle the client format
    if (typeof option === 'object' && 'idClient' in option && 'raisonSocial' in option) {
      return {
        value: option.idClient,
        label: `${option.raisonSocial} - ${option.adresse}`
      };
    }
    // Handle the article format
    if (typeof option === 'object' && 'id' in option && 'designation' in option) {
      return {
        value: option.id,
        label: option.designation
      };
    }
    // Handle simple string options
    return {
      value: option,
      label: option
    };
  });

  // Find the selected option object
  const selectedOption = formattedOptions.find(option => option.value === value) || null;

  // Handle change event
  const handleChange = (selectedOption) => {
    const newValue = selectedOption ? selectedOption.value : '';
    // Support both direct callback and event-like callback patterns
    if (typeof onChange === 'function') {
      // For direct callbacks like setUserId
      onChange(newValue);
    }
  };

  // Custom styles to match the existing input styling
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      padding: '2px',
      borderRadius: '4px',
      border: '1px solid #ddd',
      width: width, // Use prop width or default to 100%
      boxSizing: 'border-box',
      minHeight: '42px', // Match the height of existing inputs
      fontSize: '16px',
      boxShadow: state.isFocused ? '0 0 0 1px #007bff' : 'none',
      borderColor: state.isFocused ? '#007bff' : '#ddd',
      '&:hover': {
        borderColor: state.isFocused ? '#007bff' : '#ddd'
      },
      ...style
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected 
        ? '#007bff' 
        : state.isFocused 
          ? '#f8f9fa' 
          : 'white',
      color: state.isSelected ? 'white' : '#333',
      padding: '10px',
      cursor: 'pointer'
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#666'
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#333'
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      fontSize: '16px'
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px'
    }),
    input: (provided) => ({
      ...provided,
      fontSize: '16px'
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none'
    })
  };

  return (
    <div style={{ width: width }} className={className}>
      <Select
        options={formattedOptions}
        value={selectedOption}
        onChange={handleChange}
        placeholder={placeholder}
        isLoading={isLoading}
        isDisabled={isDisabled}
        isSearchable={true}
        isClearable={true}
        styles={customStyles}
        noOptionsMessage={() => "Aucune option trouvée"}
        loadingMessage={() => "Chargement..."}
      />
    </div>
  );
};

export default SearchableSelect;